module.exports = __webpack_public_path__ + "img/BITS_Logo.47542b3a.png";